import { render, staticRenderFns } from "./EditRepairs.vue?vue&type=template&id=77700aaf"
import script from "./EditRepairs.vue?vue&type=script&lang=js"
export * from "./EditRepairs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports